import { err, ok, type Result } from "../result/result";

export type Identifier<TKind extends string> = Readonly<{
  kind: TKind;
  value: string;
}>;

export type IdentifierError = Readonly<{
  code: "EMPTY_IDENTIFIER" | "INVALID_IDENTIFIER";
  value: string;
}>;

const IDENTIFIER_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,191}$/;

export const makeIdentifier = <TKind extends string>(
  kind: TKind,
  value: string,
): Result<Identifier<TKind>, IdentifierError> => {
  const normalized = value.trim();
  if (normalized.length === 0) {
    return err({ code: "EMPTY_IDENTIFIER", value });
  }
  if (!IDENTIFIER_PATTERN.test(normalized)) {
    return err({ code: "INVALID_IDENTIFIER", value });
  }
  return ok({ kind, value: normalized });
};
